import { CollectionSnakeCase } from '../types';

import convertArticleItem from './convertArticleItem';

const convertCollectionItem = (data: CollectionSnakeCase[]) => {
  return data.map((item) => {
    return {
      id: item.id,
      title: item.title,
      isCollectionScrapped: item.is_collection_scrapped,
      scraps: item.scraps.map((scrap) => ({
        id: scrap.id,
        dateCreated: scrap.date_created,
        news: scrap.news
          ? convertArticleItem([scrap.news])[0]
          : {
              id: scrap.id,
              isScrapped: true,
              isExternalContent: true,
              href: scrap.external_content.url,
              title: scrap.external_content.title,
              thumbnail: scrap.external_content.image,
              description: scrap.external_content.description,
              category: '',
              categoryHref: '',
              isVisibleUtil: true,
              isVisibleCategory: false,
              author: { name: '', href: '' },
              articleInfo: { time: 0, date: '' },
            },
        profile: scrap.profile,
        dateModified: scrap.date_modified,
        externalContent: scrap.external_content,
      })),
      isFixed: item.is_fixed,
      likeCount: item.like_count,
      viewCount: item.view_count,
      dateLastOpen: item.date_last_open,
      description: item.description,
      scrappedCount: item.scrapped_count,
      thumbnail: item.thumbnail,
      thumbnailMainColor: item.thumbnail_main_color,
      isPublic: item.is_public,
      dateDeleted: item.date_deleted,
      isLiked: item.is_like,
      profile: {
        id: item.profile.id,
        image: item.profile.image,
        name: item.profile.name,
        role: item.profile.role,
        roleKor: item.profile.role_kor,
      },
      hashTags: item.hash_tags.map((tag) => ({
        id: tag.id,
        name: tag.name,
        slug: tag.slug,
        totalUses: tag.total_uses,
        collectionUses: tag.collection_uses,
      })),
    };
  });
};

export default convertCollectionItem;
